<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card class="overlay-card overflow-hidden w-full">
          <template slot="no-body">
            <img
              :src="detail.data.image"
              alt="user-profile-cover"
              class="responsive"
            />
            <div class="card-overlay text-white flex flex-col justify-between">
              <h4 class="text-white mb-4">{{ detail.data.project }}</h4>
              <p>{{ detail.data.description }}</p>
            </div>
          </template>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card title="Detail">
          <h6>Freundlichkeit</h6>

          <star-rating
            @rating-selected="updateRating"

            v-model="rating[0]"
          />
          <h6>Qualität</h6>

          <star-rating
            @rating-selected="updateRating"

            v-model="rating[1]"
          />
          <h6>Pünktlichkeit</h6>

          <star-rating
            @rating-selected="updateRating"

            v-model="rating[2]"
          />
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base">
        <vx-card title="Tasks">
          <ul>
            <li
              v-for="(value, index) in detail.task"
              :key="index"
              class="flex mb-3 justify-between"
            >

              <span v-if="value.status != null" class="flex items-center">
                <span
                  class="
                    inline-block
                    h-4
                    w-4
                    rounded-full
                    mr-2
                    bg-white
                    border-3 border-solid
                  "
                ></span>
                <span class="font-semibold">{{ value.task }}</span>
              </span>
              <span v-if="value.status != null">{{ value.status }}</span>
              <vs-button v-if="value.status != null"

                color="primary"
                icon="images"
                @click="openPopup(value)"
                ></vs-button>


            </li>
          </ul>
          <vs-prompt
            class="mt-4 mr-2 shadow-lg"
            type="border"
            color="#7367F0"
            gradient-color-secondary="#0158A3"
            title="Task"
            accept-text="Close"
            :active.sync="activePrompt"
          >
            <div>

                <div class="product-img-container w-3/5 mx-auto mb-10 md:mb-0">
                  <span>Image Before Work</span>
                  <img
                    v-if="before_work_pic === ''"
                    src="https://icon2.cleanpng.com/20180605/ijl/kisspng-computer-icons-image-file-formats-no-image-5b16ff0d2414b5.0787389815282337411478.jpg"
                    alt="Before work"
                    class="responsive"
                  />
                  <img
                    v-else
                    :src="before_work_pic"
                    alt="Before work"
                    class="responsive"
                  />
                </div>
                <div class="product-img-container w-3/5 mx-auto mb-10 md:mb-0">
                  <span>Image After Work</span>
                  <img
                    v-if="after_work_pic === ''"
                    src="https://icon2.cleanpng.com/20180605/ijl/kisspng-computer-icons-image-file-formats-no-image-5b16ff0d2414b5.0787389815282337411478.jpg"
                    alt="After work"
                    class="responsive"
                  />
                  <img
                    v-else
                    :src="after_work_pic"
                    alt="After work"
                    class="responsive"
                  />
                </div>

            </div>
          </vs-prompt>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/axios'
import StarRating from 'vue-star-rating'


export default {
  data () {
    return {
      rating: [],
      detail: [],
      activePrompt: false,
      after_work_pic: '',
      before_work_pic: ''

    }
  },
  components: {
    StarRating
  },

  methods: {
    openPopup(taskparameter){
        this.activePrompt = true
       this.$store.dispatch('todo/fetchSingleTask', taskparameter.id).then((response) => {
        console.log(response.data.task.after_work)
        this.after_work_pic = response.data.task.after_work
        this.before_work_pic = response.data.task.before_work
        console.log(this.before_work_pic)
      })

    },
    fetchProject () {
      const id = this.$route.params.id
      axios.get(`api/project/show/${id}`).then((response) => {
        this.detail = response.data

          for (let i = 0; i < JSON.parse(this.detail.data.rate).length; i++) {
        this.rating[i] = JSON.parse(this.detail.data.rate)[i] == null ? 0 : parseInt(JSON.parse(this.detail.data.rate)[i]);
      }
      })
    },
    updateRating () {
      const rating = this.rating

      const payload = {
        id: this.$route.params.id,
        rating: JSON.stringify(rating),

      }
      console.log(payload);
      this.$store
        .dispatch('project/updateRating', payload)
        .then((response) => {
          if (response.status === 200) {
            this.$vs.notify({
              title:'Successful',
              text: response.data.msg,
              color: 'success'
            })
          } else if (response.status === 201) {
            this.$vs.notify({
              title: 'Successful',
              text: response.data.msg,
              color: 'success'
            })
          }

        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          this.fetchProject()
        })
    }
  },
  mounted () {

    this.fetchProject()
  }
}
</script>
